// Auto-generated file
import dc_down_lights__6인치_20W_방습_details_방습_루스타6인치20 from "assets/images/products/dc_down_lights_/6인치_20W_방습/details/방습_루스타6인치20.jpg";
import dc_down_lights__6인치_20W_방습_thumbnails_01 from "assets/images/products/dc_down_lights_/6인치_20W_방습/thumbnails/01.jpg";
import dc_down_lights__6인치_20W_방습_thumbnails_02 from "assets/images/products/dc_down_lights_/6인치_20W_방습/thumbnails/02.jpg";
import dc_down_lights__6인치_20W_방습_thumbnails_03 from "assets/images/products/dc_down_lights_/6인치_20W_방습/thumbnails/03.jpg";
import dc_down_lights__6인치_20W_방습_thumbnails_04 from "assets/images/products/dc_down_lights_/6인치_20W_방습/thumbnails/04.jpg";
import dc_down_lights__6인치_20W_방습_thumbnails_05 from "assets/images/products/dc_down_lights_/6인치_20W_방습/thumbnails/05.jpg";
import dc_down_lights__6인치_20W_details_루스타6인치20 from "assets/images/products/dc_down_lights_/6인치_20W/details/루스타6인치20.jpg";
import dc_down_lights__6인치_20W_thumbnails_01 from "assets/images/products/dc_down_lights_/6인치_20W/thumbnails/01.jpg";
import dc_down_lights__6인치_20W_thumbnails_02 from "assets/images/products/dc_down_lights_/6인치_20W/thumbnails/02.jpg";
import dc_down_lights__6인치_20W_thumbnails_03 from "assets/images/products/dc_down_lights_/6인치_20W/thumbnails/03.jpg";
import dc_down_lights__6인치_20W_thumbnails_04 from "assets/images/products/dc_down_lights_/6인치_20W/thumbnails/04.jpg";
import dc_down_lights__6인치_20W_thumbnails_05 from "assets/images/products/dc_down_lights_/6인치_20W/thumbnails/05.jpg";
import dc_down_lights__6인치_15W_방습_details_방습_루스타6인치 from "assets/images/products/dc_down_lights_/6인치_15W_방습/details/방습_루스타6인치.jpg";
import dc_down_lights__6인치_15W_방습_thumbnails_01 from "assets/images/products/dc_down_lights_/6인치_15W_방습/thumbnails/01.jpg";
import dc_down_lights__6인치_15W_방습_thumbnails_02 from "assets/images/products/dc_down_lights_/6인치_15W_방습/thumbnails/02.jpg";
import dc_down_lights__6인치_15W_방습_thumbnails_03 from "assets/images/products/dc_down_lights_/6인치_15W_방습/thumbnails/03.jpg";
import dc_down_lights__6인치_15W_방습_thumbnails_04 from "assets/images/products/dc_down_lights_/6인치_15W_방습/thumbnails/04.jpg";
import dc_down_lights__6인치_15W_방습_thumbnails_05 from "assets/images/products/dc_down_lights_/6인치_15W_방습/thumbnails/05.jpg";
import dc_down_lights__6인치_15W_details_루스타6인치 from "assets/images/products/dc_down_lights_/6인치_15W/details/루스타6인치.jpg";
import dc_down_lights__6인치_15W_thumbnails_01 from "assets/images/products/dc_down_lights_/6인치_15W/thumbnails/01.jpg";
import dc_down_lights__6인치_15W_thumbnails_02 from "assets/images/products/dc_down_lights_/6인치_15W/thumbnails/02.jpg";
import dc_down_lights__6인치_15W_thumbnails_03 from "assets/images/products/dc_down_lights_/6인치_15W/thumbnails/03.jpg";
import dc_down_lights__6인치_15W_thumbnails_04 from "assets/images/products/dc_down_lights_/6인치_15W/thumbnails/04.jpg";
import dc_down_lights__6인치_15W_thumbnails_05 from "assets/images/products/dc_down_lights_/6인치_15W/thumbnails/05.jpg";
import dc_down_lights__5인치_방습_details_방습_루스타5인치 from "assets/images/products/dc_down_lights_/5인치_방습/details/방습_루스타5인치.jpg";
import dc_down_lights__5인치_방습_thumbnails_01 from "assets/images/products/dc_down_lights_/5인치_방습/thumbnails/01.jpg";
import dc_down_lights__5인치_방습_thumbnails_02 from "assets/images/products/dc_down_lights_/5인치_방습/thumbnails/02.jpg";
import dc_down_lights__5인치_방습_thumbnails_03 from "assets/images/products/dc_down_lights_/5인치_방습/thumbnails/03.jpg";
import dc_down_lights__5인치_방습_thumbnails_04 from "assets/images/products/dc_down_lights_/5인치_방습/thumbnails/04.jpg";
import dc_down_lights__5인치_방습_thumbnails_05 from "assets/images/products/dc_down_lights_/5인치_방습/thumbnails/05.jpg";
import dc_down_lights__5인치_details_루스타5인치 from "assets/images/products/dc_down_lights_/5인치/details/루스타5인치.jpg";
import dc_down_lights__5인치_thumbnails_01 from "assets/images/products/dc_down_lights_/5인치/thumbnails/01.jpg";
import dc_down_lights__5인치_thumbnails_02 from "assets/images/products/dc_down_lights_/5인치/thumbnails/02.jpg";
import dc_down_lights__5인치_thumbnails_03 from "assets/images/products/dc_down_lights_/5인치/thumbnails/03.jpg";
import dc_down_lights__5인치_thumbnails_04 from "assets/images/products/dc_down_lights_/5인치/thumbnails/04.jpg";
import dc_down_lights__5인치_thumbnails_05 from "assets/images/products/dc_down_lights_/5인치/thumbnails/05.jpg";
import dc_down_lights__4인치_방습_details_방습_루스타4인치 from "assets/images/products/dc_down_lights_/4인치_방습/details/방습_루스타4인치.jpg";
import dc_down_lights__4인치_방습_thumbnails_01 from "assets/images/products/dc_down_lights_/4인치_방습/thumbnails/01.jpg";
import dc_down_lights__4인치_방습_thumbnails_02 from "assets/images/products/dc_down_lights_/4인치_방습/thumbnails/02.jpg";
import dc_down_lights__4인치_방습_thumbnails_03 from "assets/images/products/dc_down_lights_/4인치_방습/thumbnails/03.jpg";
import dc_down_lights__4인치_방습_thumbnails_04 from "assets/images/products/dc_down_lights_/4인치_방습/thumbnails/04.jpg";
import dc_down_lights__4인치_방습_thumbnails_05 from "assets/images/products/dc_down_lights_/4인치_방습/thumbnails/05.jpg";
import dc_down_lights__4인치_details_루스타4인치 from "assets/images/products/dc_down_lights_/4인치/details/루스타4인치.jpg";
import dc_down_lights__4인치_thumbnails_01 from "assets/images/products/dc_down_lights_/4인치/thumbnails/01.jpg";
import dc_down_lights__4인치_thumbnails_02 from "assets/images/products/dc_down_lights_/4인치/thumbnails/02.jpg";
import dc_down_lights__4인치_thumbnails_03 from "assets/images/products/dc_down_lights_/4인치/thumbnails/03.jpg";
import dc_down_lights__4인치_thumbnails_04 from "assets/images/products/dc_down_lights_/4인치/thumbnails/04.jpg";
import dc_down_lights__4인치_thumbnails_05 from "assets/images/products/dc_down_lights_/4인치/thumbnails/05.jpg";
import dc_down_lights__3인치_방습_details_방습_루스타3인치 from "assets/images/products/dc_down_lights_/3인치_방습/details/방습_루스타3인치.jpg";
import dc_down_lights__3인치_방습_thumbnails_01 from "assets/images/products/dc_down_lights_/3인치_방습/thumbnails/01.jpg";
import dc_down_lights__3인치_방습_thumbnails_02 from "assets/images/products/dc_down_lights_/3인치_방습/thumbnails/02.jpg";
import dc_down_lights__3인치_방습_thumbnails_03 from "assets/images/products/dc_down_lights_/3인치_방습/thumbnails/03.jpg";
import dc_down_lights__3인치_방습_thumbnails_04 from "assets/images/products/dc_down_lights_/3인치_방습/thumbnails/04.jpg";
import dc_down_lights__3인치_방습_thumbnails_05 from "assets/images/products/dc_down_lights_/3인치_방습/thumbnails/05.jpg";
import dc_down_lights__3인치_details_루스타3인치 from "assets/images/products/dc_down_lights_/3인치/details/루스타3인치.jpg";
import dc_down_lights__3인치_thumbnails_01 from "assets/images/products/dc_down_lights_/3인치/thumbnails/01.jpg";
import dc_down_lights__3인치_thumbnails_02 from "assets/images/products/dc_down_lights_/3인치/thumbnails/02.jpg";
import dc_down_lights__3인치_thumbnails_03 from "assets/images/products/dc_down_lights_/3인치/thumbnails/03.jpg";
import dc_down_lights__3인치_thumbnails_04 from "assets/images/products/dc_down_lights_/3인치/thumbnails/04.jpg";
import dc_down_lights__3인치_thumbnails_05 from "assets/images/products/dc_down_lights_/3인치/thumbnails/05.jpg";
import dc_down_lights__2인치_방습_details_방습_루스타2인치 from "assets/images/products/dc_down_lights_/2인치_방습/details/방습_루스타2인치.jpg";
import dc_down_lights__2인치_방습_thumbnails_01 from "assets/images/products/dc_down_lights_/2인치_방습/thumbnails/01.jpg";
import dc_down_lights__2인치_방습_thumbnails_02 from "assets/images/products/dc_down_lights_/2인치_방습/thumbnails/02.jpg";
import dc_down_lights__2인치_방습_thumbnails_03 from "assets/images/products/dc_down_lights_/2인치_방습/thumbnails/03.jpg";
import dc_down_lights__2인치_방습_thumbnails_04 from "assets/images/products/dc_down_lights_/2인치_방습/thumbnails/04.jpg";
import dc_down_lights__2인치_방습_thumbnails_05 from "assets/images/products/dc_down_lights_/2인치_방습/thumbnails/05.jpg";
import dc_down_lights__2인치_details_루스타2인치 from "assets/images/products/dc_down_lights_/2인치/details/루스타2인치.jpg";
import dc_down_lights__2인치_thumbnails_01 from "assets/images/products/dc_down_lights_/2인치/thumbnails/01.jpg";
import dc_down_lights__2인치_thumbnails_02 from "assets/images/products/dc_down_lights_/2인치/thumbnails/02.jpg";
import dc_down_lights__2인치_thumbnails_03 from "assets/images/products/dc_down_lights_/2인치/thumbnails/03.jpg";
import dc_down_lights__2인치_thumbnails_04 from "assets/images/products/dc_down_lights_/2인치/thumbnails/04.jpg";
import dc_down_lights__2인치_thumbnails_05 from "assets/images/products/dc_down_lights_/2인치/thumbnails/05.jpg";
import dimmer__500W_조광기_details_01 from "assets/images/products/dimmer_/500W_조광기/details/01.mp4";
import dimmer__500W_조광기_details_02 from "assets/images/products/dimmer_/500W_조광기/details/02.jpg";
import dimmer__500W_조광기_thumbnails_01 from "assets/images/products/dimmer_/500W_조광기/thumbnails/01.jpg";
import dimmer__500W_조광기_thumbnails_02 from "assets/images/products/dimmer_/500W_조광기/thumbnails/02.jpg";
import dimmer__500W_조광기_thumbnails_03 from "assets/images/products/dimmer_/500W_조광기/thumbnails/03.jpg";
import dimmer__500W_조광기_thumbnails_04 from "assets/images/products/dimmer_/500W_조광기/thumbnails/04.jpg";
import dimmer__500W_조광기_thumbnails_05 from "assets/images/products/dimmer_/500W_조광기/thumbnails/05.jpg";
import dimmer__180W_조광기_details_jokyung_1 from "assets/images/products/dimmer_/180W_조광기/details/jokyung_1.jpg";
import dimmer__180W_조광기_thumbnails_jo_1 from "assets/images/products/dimmer_/180W_조광기/thumbnails/jo_1.jpg";
import dimmer__180W_조광기_thumbnails_jo_2 from "assets/images/products/dimmer_/180W_조광기/thumbnails/jo_2.jpg";
import dimmer__180W_조광기_thumbnails_jo_3 from "assets/images/products/dimmer_/180W_조광기/thumbnails/jo_3.jpg";
import down_sensr__매입센서_6인치_details_s_6in from "assets/images/products/down_sensr_/매입센서_6인치/details/s_6in.jpg";
import down_sensr__매입센서_6인치_thumbnails_sen_3in_1 from "assets/images/products/down_sensr_/매입센서_6인치/thumbnails/sen-3in-1.jpg";
import down_sensr__매입센서_5인치_details_s_5in from "assets/images/products/down_sensr_/매입센서_5인치/details/s_5in.jpg";
import down_sensr__매입센서_5인치_thumbnails_sen_3in_1 from "assets/images/products/down_sensr_/매입센서_5인치/thumbnails/sen-3in-1.jpg";
import down_sensr__매입센서_4인치_details_s_4in from "assets/images/products/down_sensr_/매입센서_4인치/details/s_4in.jpg";
import down_sensr__매입센서_4인치_thumbnails_sen_4in_1 from "assets/images/products/down_sensr_/매입센서_4인치/thumbnails/sen_4in-1.jpg";
import down_sensr__매입센서_4인치_thumbnails_sen_4in_2 from "assets/images/products/down_sensr_/매입센서_4인치/thumbnails/sen_4in-2.jpg";
import down_sensr__매입센서_4인치_thumbnails_sen_4in_3 from "assets/images/products/down_sensr_/매입센서_4인치/thumbnails/sen_4in-3.jpg";
import down_sensr__매입센서_4인치_thumbnails_sen_4in_4 from "assets/images/products/down_sensr_/매입센서_4인치/thumbnails/sen_4in-4.jpg";
import down_sensr__매입센서_4인치_thumbnails_sen_4in_5 from "assets/images/products/down_sensr_/매입센서_4인치/thumbnails/sen_4in-5.jpg";
import down_sensr__매입센서_4인치_thumbnails_sen_4in from "assets/images/products/down_sensr_/매입센서_4인치/thumbnails/sen_4in.jpg";
import down_sensr__매입센서_3인치_details_s_3in from "assets/images/products/down_sensr_/매입센서_3인치/details/s_3in.jpg";
import down_sensr__매입센서_3인치_thumbnails_sen_3in_1 from "assets/images/products/down_sensr_/매입센서_3인치/thumbnails/sen-3in-1.jpg";
import high_down_lights__6인치_고효율_매입등_details_go_6in from "assets/images/products/high_down_lights_/6인치_고효율_매입등/details/go_6in.jpg";
import high_down_lights__6인치_고효율_매입등_thumbnails_3in from "assets/images/products/high_down_lights_/6인치_고효율_매입등/thumbnails/3in.png";
import high_down_lights__4인치_고효율_매입등_details_go_4in_tot from "assets/images/products/high_down_lights_/4인치_고효율_매입등/details/go_4in_tot.jpg";
import high_down_lights__4인치_고효율_매입등_thumbnails_3in from "assets/images/products/high_down_lights_/4인치_고효율_매입등/thumbnails/3in.png";
import high_down_lights__3인치_고효율_매입등_details_go_3in_tot from "assets/images/products/high_down_lights_/3인치_고효율_매입등/details/go_3in_tot.jpg";
import high_down_lights__3인치_고효율_매입등_thumbnails_3in from "assets/images/products/high_down_lights_/3인치_고효율_매입등/thumbnails/3in.png";
import ic_down_lights_IC_매입등_8인치_방습_details_water_8in_down_35w from "assets/images/products/ic_down_lights/IC_매입등_8인치_방습/details/water_8in_down_35w.jpg";
import ic_down_lights_IC_매입등_8인치_방습_thumbnails_8in from "assets/images/products/ic_down_lights/IC_매입등_8인치_방습/thumbnails/8in.jpg";
import ic_down_lights_IC_매입등_8인치_details_8in_down_35w from "assets/images/products/ic_down_lights/IC_매입등_8인치/details/8in_down_35w.jpg";
import ic_down_lights_IC_매입등_8인치_thumbnails_8in from "assets/images/products/ic_down_lights/IC_매입등_8인치/thumbnails/8in.jpg";
import ic_down_lights_IC_매입등_6인치_20W_방습_details_water_6in_down_20w from "assets/images/products/ic_down_lights/IC_매입등_6인치_20W_방습/details/water_6in_down_20w.jpg";
import ic_down_lights_IC_매입등_6인치_20W_방습_thumbnails_01 from "assets/images/products/ic_down_lights/IC_매입등_6인치_20W_방습/thumbnails/01.jpg";
import ic_down_lights_IC_매입등_6인치_20W_방습_thumbnails_02 from "assets/images/products/ic_down_lights/IC_매입등_6인치_20W_방습/thumbnails/02.jpg";
import ic_down_lights_IC_매입등_6인치_20W_방습_thumbnails_03 from "assets/images/products/ic_down_lights/IC_매입등_6인치_20W_방습/thumbnails/03.psd";
import ic_down_lights_IC_매입등_6인치_20W_details_6in_down_20w from "assets/images/products/ic_down_lights/IC_매입등_6인치_20W/details/6in_down_20w.jpg";
import ic_down_lights_IC_매입등_6인치_20W_thumbnails_01 from "assets/images/products/ic_down_lights/IC_매입등_6인치_20W/thumbnails/01.jpg";
import ic_down_lights_IC_매입등_6인치_20W_thumbnails_02 from "assets/images/products/ic_down_lights/IC_매입등_6인치_20W/thumbnails/02.jpg";
import ic_down_lights_IC_매입등_6인치_20W_thumbnails_03 from "assets/images/products/ic_down_lights/IC_매입등_6인치_20W/thumbnails/03.psd";
import ic_down_lights_IC_매입등_6인치_15W_방습_details_water_6in_down from "assets/images/products/ic_down_lights/IC_매입등_6인치_15W_방습/details/water_6in_down.jpg";
import ic_down_lights_IC_매입등_6인치_15W_방습_thumbnails_01 from "assets/images/products/ic_down_lights/IC_매입등_6인치_15W_방습/thumbnails/01.jpg";
import ic_down_lights_IC_매입등_6인치_15W_방습_thumbnails_02 from "assets/images/products/ic_down_lights/IC_매입등_6인치_15W_방습/thumbnails/02.jpg";
import ic_down_lights_IC_매입등_6인치_15W_방습_thumbnails_03 from "assets/images/products/ic_down_lights/IC_매입등_6인치_15W_방습/thumbnails/03.jpg";
import ic_down_lights_IC_매입등_6인치_15W_details_6in_down from "assets/images/products/ic_down_lights/IC_매입등_6인치_15W/details/6in_down.jpg";
import ic_down_lights_IC_매입등_6인치_15W_thumbnails_01 from "assets/images/products/ic_down_lights/IC_매입등_6인치_15W/thumbnails/01.jpg";
import ic_down_lights_IC_매입등_6인치_15W_thumbnails_02 from "assets/images/products/ic_down_lights/IC_매입등_6인치_15W/thumbnails/02.jpg";
import ic_down_lights_IC_매입등_6인치_15W_thumbnails_03 from "assets/images/products/ic_down_lights/IC_매입등_6인치_15W/thumbnails/03.jpg";
import ic_down_lights_IC_매입등_5인치_방습_details_water_5in_down from "assets/images/products/ic_down_lights/IC_매입등_5인치_방습/details/water_5in_down.jpg";
import ic_down_lights_IC_매입등_5인치_방습_thumbnails_5in from "assets/images/products/ic_down_lights/IC_매입등_5인치_방습/thumbnails/5in.jpg";
import ic_down_lights_IC_매입등_5인치_details_5in_down from "assets/images/products/ic_down_lights/IC_매입등_5인치/details/5in_down.jpg";
import ic_down_lights_IC_매입등_5인치_thumbnails_5in from "assets/images/products/ic_down_lights/IC_매입등_5인치/thumbnails/5in.jpg";
import ic_down_lights_IC_매입등_4인치_details_4in_down from "assets/images/products/ic_down_lights/IC_매입등_4인치/details/4in_down.jpg";
import ic_down_lights_IC_매입등_4인치_thumbnails_4in from "assets/images/products/ic_down_lights/IC_매입등_4인치/thumbnails/4in.jpg";
import ic_down_lights_IC_매입등_3인치_방습_details_water_3in_down from "assets/images/products/ic_down_lights/IC_매입등_3인치_방습/details/water_3in_down.jpg";
import ic_down_lights_IC_매입등_3인치_방습_thumbnails_01 from "assets/images/products/ic_down_lights/IC_매입등_3인치_방습/thumbnails/01.jpg";
import ic_down_lights_IC_매입등_3인치_방습_thumbnails_02 from "assets/images/products/ic_down_lights/IC_매입등_3인치_방습/thumbnails/02.jpg";
import ic_down_lights_IC_매입등_3인치_방습_thumbnails_03 from "assets/images/products/ic_down_lights/IC_매입등_3인치_방습/thumbnails/03.jpg";
import ic_down_lights_IC_매입등_3인치_방습_thumbnails_04 from "assets/images/products/ic_down_lights/IC_매입등_3인치_방습/thumbnails/04.jpg";
import ic_down_lights_IC_매입등_3인치_방습_thumbnails_05 from "assets/images/products/ic_down_lights/IC_매입등_3인치_방습/thumbnails/05.jpg";
import ic_down_lights_IC_매입등_3인치_방습_thumbnails_06 from "assets/images/products/ic_down_lights/IC_매입등_3인치_방습/thumbnails/06.jpg";
import ic_down_lights_IC_매입등_3인치_details_3in_down from "assets/images/products/ic_down_lights/IC_매입등_3인치/details/3in_down.jpg";
import ic_down_lights_IC_매입등_3인치_thumbnails_01 from "assets/images/products/ic_down_lights/IC_매입등_3인치/thumbnails/01.jpg";
import ic_down_lights_IC_매입등_3인치_thumbnails_02 from "assets/images/products/ic_down_lights/IC_매입등_3인치/thumbnails/02.jpg";
import ic_down_lights_IC_매입등_3인치_thumbnails_03 from "assets/images/products/ic_down_lights/IC_매입등_3인치/thumbnails/03.jpg";
import ic_down_lights_IC_매입등_3인치_thumbnails_04 from "assets/images/products/ic_down_lights/IC_매입등_3인치/thumbnails/04.jpg";
import ic_down_lights_IC_매입등_3인치_thumbnails_05 from "assets/images/products/ic_down_lights/IC_매입등_3인치/thumbnails/05.jpg";
import ic_down_lights_IC_매입등_3인치_thumbnails_06 from "assets/images/products/ic_down_lights/IC_매입등_3인치/thumbnails/06.jpg";
import recessed_down_lights_음푹매입등_확산_4인치_details_확산움푹4인치상세 from "assets/images/products/recessed_down_lights/음푹매입등_확산_4인치/details/확산움푹4인치상세.jpg";
import recessed_down_lights_음푹매입등_확산_4인치_thumbnails_01 from "assets/images/products/recessed_down_lights/음푹매입등_확산_4인치/thumbnails/01.png";
import recessed_down_lights_음푹매입등_확산_4인치_thumbnails_02 from "assets/images/products/recessed_down_lights/음푹매입등_확산_4인치/thumbnails/02.png";
import recessed_down_lights_음푹매입등_확산_4인치_thumbnails_03 from "assets/images/products/recessed_down_lights/음푹매입등_확산_4인치/thumbnails/03.png";
import recessed_down_lights_음푹매입등_확산_4인치_thumbnails_04 from "assets/images/products/recessed_down_lights/음푹매입등_확산_4인치/thumbnails/04.png";
import recessed_down_lights_음푹매입등_확산_4인치_thumbnails_05 from "assets/images/products/recessed_down_lights/음푹매입등_확산_4인치/thumbnails/05.png";
import recessed_down_lights_음푹매입등_확산_4인치_thumbnails_06 from "assets/images/products/recessed_down_lights/음푹매입등_확산_4인치/thumbnails/06.png";
import recessed_down_lights_음푹매입등_확산_3인치_details_움푹3인치상세 from "assets/images/products/recessed_down_lights/음푹매입등_확산_3인치/details/움푹3인치상세.jpg";
import recessed_down_lights_음푹매입등_확산_3인치_thumbnails_01 from "assets/images/products/recessed_down_lights/음푹매입등_확산_3인치/thumbnails/01.png";
import recessed_down_lights_음푹매입등_확산_3인치_thumbnails_02 from "assets/images/products/recessed_down_lights/음푹매입등_확산_3인치/thumbnails/02.png";
import recessed_down_lights_음푹매입등_확산_3인치_thumbnails_03 from "assets/images/products/recessed_down_lights/음푹매입등_확산_3인치/thumbnails/03.png";
import recessed_down_lights_음푹매입등_확산_3인치_thumbnails_04 from "assets/images/products/recessed_down_lights/음푹매입등_확산_3인치/thumbnails/04.png";
import recessed_down_lights_음푹매입등_확산_3인치_thumbnails_05 from "assets/images/products/recessed_down_lights/음푹매입등_확산_3인치/thumbnails/05.png";
import recessed_down_lights_음푹매입등_확산_3인치_thumbnails_06 from "assets/images/products/recessed_down_lights/음푹매입등_확산_3인치/thumbnails/06.png";
import recessed_down_lights_음푹매입등_확산_2인치_details_확산움푹2인치상세 from "assets/images/products/recessed_down_lights/음푹매입등_확산_2인치/details/확산움푹2인치상세.jpg";
import recessed_down_lights_음푹매입등_확산_2인치_thumbnails_01 from "assets/images/products/recessed_down_lights/음푹매입등_확산_2인치/thumbnails/01.png";
import recessed_down_lights_음푹매입등_확산_2인치_thumbnails_02 from "assets/images/products/recessed_down_lights/음푹매입등_확산_2인치/thumbnails/02.png";
import recessed_down_lights_음푹매입등_확산_2인치_thumbnails_03 from "assets/images/products/recessed_down_lights/음푹매입등_확산_2인치/thumbnails/03.png";
import recessed_down_lights_음푹매입등_확산_2인치_thumbnails_04 from "assets/images/products/recessed_down_lights/음푹매입등_확산_2인치/thumbnails/04.png";
import recessed_down_lights_음푹매입등_확산_2인치_thumbnails_05 from "assets/images/products/recessed_down_lights/음푹매입등_확산_2인치/thumbnails/05.png";
import recessed_down_lights_음푹매입등_확산_2인치_thumbnails_06 from "assets/images/products/recessed_down_lights/음푹매입등_확산_2인치/thumbnails/06.png";
import recessed_down_lights_음푹매입등_집중_4인치_화이트_details_집중_화이트_4인치 from "assets/images/products/recessed_down_lights/음푹매입등_집중_4인치_화이트/details/집중_화이트_4인치.jpg";
import recessed_down_lights_음푹매입등_집중_4인치_화이트_thumbnails_02 from "assets/images/products/recessed_down_lights/음푹매입등_집중_4인치_화이트/thumbnails/02.jpg";
import recessed_down_lights_음푹매입등_집중_4인치_화이트_thumbnails_03 from "assets/images/products/recessed_down_lights/음푹매입등_집중_4인치_화이트/thumbnails/03.jpg";
import recessed_down_lights_음푹매입등_집중_4인치_화이트_thumbnails_04 from "assets/images/products/recessed_down_lights/음푹매입등_집중_4인치_화이트/thumbnails/04.jpg";
import recessed_down_lights_음푹매입등_집중_4인치_블랙_details_집중_블랙_4인치 from "assets/images/products/recessed_down_lights/음푹매입등_집중_4인치_블랙/details/집중_블랙_4인치.jpg";
import recessed_down_lights_음푹매입등_집중_4인치_블랙_thumbnails_01 from "assets/images/products/recessed_down_lights/음푹매입등_집중_4인치_블랙/thumbnails/01.jpg";
import recessed_down_lights_음푹매입등_집중_4인치_블랙_thumbnails_05 from "assets/images/products/recessed_down_lights/음푹매입등_집중_4인치_블랙/thumbnails/05.jpg";
import recessed_down_lights_음푹매입등_집중_4인치_블랙_thumbnails_06 from "assets/images/products/recessed_down_lights/음푹매입등_집중_4인치_블랙/thumbnails/06.jpg";
import recessed_down_lights_음푹매입등_집중_3인치_화이트_details_집중_화이트_3인치 from "assets/images/products/recessed_down_lights/음푹매입등_집중_3인치_화이트/details/집중_화이트_3인치.jpg";
import recessed_down_lights_음푹매입등_집중_3인치_화이트_thumbnails_02 from "assets/images/products/recessed_down_lights/음푹매입등_집중_3인치_화이트/thumbnails/02.jpg";
import recessed_down_lights_음푹매입등_집중_3인치_화이트_thumbnails_03 from "assets/images/products/recessed_down_lights/음푹매입등_집중_3인치_화이트/thumbnails/03.jpg";
import recessed_down_lights_음푹매입등_집중_3인치_화이트_thumbnails_04 from "assets/images/products/recessed_down_lights/음푹매입등_집중_3인치_화이트/thumbnails/04.jpg";
import recessed_down_lights_음푹매입등_집중_3인치_블랙_details_집중_블랙_3인치 from "assets/images/products/recessed_down_lights/음푹매입등_집중_3인치_블랙/details/집중_블랙_3인치.jpg";
import recessed_down_lights_음푹매입등_집중_3인치_블랙_thumbnails_01 from "assets/images/products/recessed_down_lights/음푹매입등_집중_3인치_블랙/thumbnails/01.jpg";
import recessed_down_lights_음푹매입등_집중_3인치_블랙_thumbnails_05 from "assets/images/products/recessed_down_lights/음푹매입등_집중_3인치_블랙/thumbnails/05.jpg";
import recessed_down_lights_음푹매입등_집중_3인치_블랙_thumbnails_06 from "assets/images/products/recessed_down_lights/음푹매입등_집중_3인치_블랙/thumbnails/06.jpg";
import recessed_down_lights_음푹매입등_집중_2인치_화이트_details_집중_화이트_2인치 from "assets/images/products/recessed_down_lights/음푹매입등_집중_2인치_화이트/details/집중_화이트_2인치.jpg";
import recessed_down_lights_음푹매입등_집중_2인치_화이트_thumbnails_02 from "assets/images/products/recessed_down_lights/음푹매입등_집중_2인치_화이트/thumbnails/02.jpg";
import recessed_down_lights_음푹매입등_집중_2인치_화이트_thumbnails_03 from "assets/images/products/recessed_down_lights/음푹매입등_집중_2인치_화이트/thumbnails/03.jpg";
import recessed_down_lights_음푹매입등_집중_2인치_화이트_thumbnails_04 from "assets/images/products/recessed_down_lights/음푹매입등_집중_2인치_화이트/thumbnails/04.jpg";
import recessed_down_lights_음푹매입등_집중_2인치_블랙_details_집중_블랙_2인치 from "assets/images/products/recessed_down_lights/음푹매입등_집중_2인치_블랙/details/집중_블랙_2인치.jpg";
import recessed_down_lights_음푹매입등_집중_2인치_블랙_thumbnails_01 from "assets/images/products/recessed_down_lights/음푹매입등_집중_2인치_블랙/thumbnails/01.jpg";
import recessed_down_lights_음푹매입등_집중_2인치_블랙_thumbnails_05 from "assets/images/products/recessed_down_lights/음푹매입등_집중_2인치_블랙/thumbnails/05.jpg";
import recessed_down_lights_음푹매입등_집중_2인치_블랙_thumbnails_06 from "assets/images/products/recessed_down_lights/음푹매입등_집중_2인치_블랙/thumbnails/06.jpg";
import rf_sensr__히든센서200_details_200_ss from "assets/images/products/rf_sensr_/히든센서200/details/200_ss.jpg";
import rf_sensr__히든센서200_thumbnails_01 from "assets/images/products/rf_sensr_/히든센서200/thumbnails/01.jpg";
import rf_sensr__히든센서200_thumbnails_02 from "assets/images/products/rf_sensr_/히든센서200/thumbnails/02.jpg";
import rf_sensr__히든센서200_thumbnails_03 from "assets/images/products/rf_sensr_/히든센서200/thumbnails/03.jpg";
import rf_sensr__히든센서200_thumbnails_04 from "assets/images/products/rf_sensr_/히든센서200/thumbnails/04.jpg";
import rf_sensr__히든센서200_thumbnails_05 from "assets/images/products/rf_sensr_/히든센서200/thumbnails/05.jpg";
import rf_sensr__히든센서1000_details_01 from "assets/images/products/rf_sensr_/히든센서1000/details/01.jpg";
import rf_sensr__히든센서1000_thumbnails_01 from "assets/images/products/rf_sensr_/히든센서1000/thumbnails/01.jpg";
import rf_sensr__히든센서1000_thumbnails_02 from "assets/images/products/rf_sensr_/히든센서1000/thumbnails/02.jpg";
import rf_sensr__히든센서1000_thumbnails_03 from "assets/images/products/rf_sensr_/히든센서1000/thumbnails/03.jpg";
import rf_sensr__히든센서1000_thumbnails_04 from "assets/images/products/rf_sensr_/히든센서1000/thumbnails/04.jpg";
import rf_sensr__벽부형센서_details_KakaoTalk_20241216_151540344 from "assets/images/products/rf_sensr_/벽부형센서/details/KakaoTalk_20241216_151540344.jpg";
import rf_sensr__벽부형센서_details_KakaoTalk_20241216_151540344_01 from "assets/images/products/rf_sensr_/벽부형센서/details/KakaoTalk_20241216_151540344_01.jpg";
import rf_sensr__벽부형센서_details_KakaoTalk_20241216_151540344_02 from "assets/images/products/rf_sensr_/벽부형센서/details/KakaoTalk_20241216_151540344_02.jpg";
import rf_sensr__벽부형센서_details_KakaoTalk_20241216_151540344_03 from "assets/images/products/rf_sensr_/벽부형센서/details/KakaoTalk_20241216_151540344_03.jpg";
import rf_sensr__벽부형센서_details_KakaoTalk_20241216_151540344_04 from "assets/images/products/rf_sensr_/벽부형센서/details/KakaoTalk_20241216_151540344_04.jpg";
import rf_sensr__벽부형센서_thumbnails_01 from "assets/images/products/rf_sensr_/벽부형센서/thumbnails/01.jpg";
import rf_sensr__벽부형센서_thumbnails_02 from "assets/images/products/rf_sensr_/벽부형센서/thumbnails/02.jpg";
import rf_sensr__벽부형센서_thumbnails_03 from "assets/images/products/rf_sensr_/벽부형센서/thumbnails/03.jpg";
import rf_sensr__벽부형센서_thumbnails_04 from "assets/images/products/rf_sensr_/벽부형센서/thumbnails/04.jpg";

const lightsData = {
  categories: [
    {
      id: "dc_down_lights_",
      name: "dc_down_lights_",
      title: "DC 매입등",
      description: "",
      items: [
        {
          id: "dc_down_lights__1",
          name: "6인치_20W_방습",
          details: [dc_down_lights__6인치_20W_방습_details_방습_루스타6인치20],
          thumbnails: [
            dc_down_lights__6인치_20W_방습_thumbnails_01,
            dc_down_lights__6인치_20W_방습_thumbnails_02,
            dc_down_lights__6인치_20W_방습_thumbnails_03,
            dc_down_lights__6인치_20W_방습_thumbnails_04,
            dc_down_lights__6인치_20W_방습_thumbnails_05,
          ],
          energy: true,
          water: true,
        },
        {
          id: "dc_down_lights__2",
          name: "6인치_20W",
          details: [dc_down_lights__6인치_20W_details_루스타6인치20],
          thumbnails: [
            dc_down_lights__6인치_20W_thumbnails_01,
            dc_down_lights__6인치_20W_thumbnails_02,
            dc_down_lights__6인치_20W_thumbnails_03,
            dc_down_lights__6인치_20W_thumbnails_04,
            dc_down_lights__6인치_20W_thumbnails_05,
          ],
          energy: true,
          water: false,
        },
        {
          id: "dc_down_lights__3",
          name: "6인치_15W_방습",
          details: [dc_down_lights__6인치_15W_방습_details_방습_루스타6인치],
          thumbnails: [
            dc_down_lights__6인치_15W_방습_thumbnails_01,
            dc_down_lights__6인치_15W_방습_thumbnails_02,
            dc_down_lights__6인치_15W_방습_thumbnails_03,
            dc_down_lights__6인치_15W_방습_thumbnails_04,
            dc_down_lights__6인치_15W_방습_thumbnails_05,
          ],
          energy: true,
          water: true,
        },
        {
          id: "dc_down_lights__4",
          name: "6인치_15W",
          details: [dc_down_lights__6인치_15W_details_루스타6인치],
          thumbnails: [
            dc_down_lights__6인치_15W_thumbnails_01,
            dc_down_lights__6인치_15W_thumbnails_02,
            dc_down_lights__6인치_15W_thumbnails_03,
            dc_down_lights__6인치_15W_thumbnails_04,
            dc_down_lights__6인치_15W_thumbnails_05,
          ],
          energy: true,
          water: false,
        },
        {
          id: "dc_down_lights__5",
          name: "5인치_방습",
          details: [dc_down_lights__5인치_방습_details_방습_루스타5인치],
          thumbnails: [
            dc_down_lights__5인치_방습_thumbnails_01,
            dc_down_lights__5인치_방습_thumbnails_02,
            dc_down_lights__5인치_방습_thumbnails_03,
            dc_down_lights__5인치_방습_thumbnails_04,
            dc_down_lights__5인치_방습_thumbnails_05,
          ],
          energy: true,
          water: true,
        },
        {
          id: "dc_down_lights__6",
          name: "5인치",
          details: [dc_down_lights__5인치_details_루스타5인치],
          thumbnails: [
            dc_down_lights__5인치_thumbnails_01,
            dc_down_lights__5인치_thumbnails_02,
            dc_down_lights__5인치_thumbnails_03,
            dc_down_lights__5인치_thumbnails_04,
            dc_down_lights__5인치_thumbnails_05,
          ],
          energy: true,
          water: false,
        },
        {
          id: "dc_down_lights__7",
          name: "4인치_방습",
          details: [dc_down_lights__4인치_방습_details_방습_루스타4인치],
          thumbnails: [
            dc_down_lights__4인치_방습_thumbnails_01,
            dc_down_lights__4인치_방습_thumbnails_02,
            dc_down_lights__4인치_방습_thumbnails_03,
            dc_down_lights__4인치_방습_thumbnails_04,
            dc_down_lights__4인치_방습_thumbnails_05,
          ],
          energy: true,
          water: true,
        },
        {
          id: "dc_down_lights__8",
          name: "4인치",
          details: [dc_down_lights__4인치_details_루스타4인치],
          thumbnails: [
            dc_down_lights__4인치_thumbnails_01,
            dc_down_lights__4인치_thumbnails_02,
            dc_down_lights__4인치_thumbnails_03,
            dc_down_lights__4인치_thumbnails_04,
            dc_down_lights__4인치_thumbnails_05,
          ],
          energy: true,
          water: false,
        },
        {
          id: "dc_down_lights__9",
          name: "3인치_방습",
          details: [dc_down_lights__3인치_방습_details_방습_루스타3인치],
          thumbnails: [
            dc_down_lights__3인치_방습_thumbnails_01,
            dc_down_lights__3인치_방습_thumbnails_02,
            dc_down_lights__3인치_방습_thumbnails_03,
            dc_down_lights__3인치_방습_thumbnails_04,
            dc_down_lights__3인치_방습_thumbnails_05,
          ],
          energy: true,
          water: true,
        },
        {
          id: "dc_down_lights__10",
          name: "3인치",
          details: [dc_down_lights__3인치_details_루스타3인치],
          thumbnails: [
            dc_down_lights__3인치_thumbnails_01,
            dc_down_lights__3인치_thumbnails_02,
            dc_down_lights__3인치_thumbnails_03,
            dc_down_lights__3인치_thumbnails_04,
            dc_down_lights__3인치_thumbnails_05,
          ],
          energy: true,
          water: false,
        },
        {
          id: "dc_down_lights__11",
          name: "2인치_방습",
          details: [dc_down_lights__2인치_방습_details_방습_루스타2인치],
          thumbnails: [
            dc_down_lights__2인치_방습_thumbnails_01,
            dc_down_lights__2인치_방습_thumbnails_02,
            dc_down_lights__2인치_방습_thumbnails_03,
            dc_down_lights__2인치_방습_thumbnails_04,
            dc_down_lights__2인치_방습_thumbnails_05,
          ],
          energy: true,
          water: true,
        },
        {
          id: "dc_down_lights__12",
          name: "2인치",
          details: [dc_down_lights__2인치_details_루스타2인치],
          thumbnails: [
            dc_down_lights__2인치_thumbnails_01,
            dc_down_lights__2인치_thumbnails_02,
            dc_down_lights__2인치_thumbnails_03,
            dc_down_lights__2인치_thumbnails_04,
            dc_down_lights__2인치_thumbnails_05,
          ],
          energy: true,
          water: false,
        },
      ],
    },
    {
      id: "dimmer_",
      name: "dimmer_",
      title: "조광기",
      description: "",
      items: [
        {
          id: "dimmer__1",
          name: "500W_조광기",
          details: [dimmer__500W_조광기_details_01, dimmer__500W_조광기_details_02],
          thumbnails: [
            dimmer__500W_조광기_thumbnails_01,
            dimmer__500W_조광기_thumbnails_02,
            dimmer__500W_조광기_thumbnails_03,
            dimmer__500W_조광기_thumbnails_04,
            dimmer__500W_조광기_thumbnails_05,
          ],
          energy: true,
          water: false,
        },
        {
          id: "dimmer__2",
          name: "180W_조광기",
          details: [dimmer__180W_조광기_details_jokyung_1],
          thumbnails: [
            dimmer__180W_조광기_thumbnails_jo_1,
            dimmer__180W_조광기_thumbnails_jo_2,
            dimmer__180W_조광기_thumbnails_jo_3,
          ],
          energy: true,
          water: false,
        },
      ],
    },
    {
      id: "down_sensr_",
      name: "down_sensr_",
      title: "매입 센서등",
      description: "",
      items: [
        {
          id: "down_sensr__1",
          name: "매입센서_6인치",
          details: [down_sensr__매입센서_6인치_details_s_6in],
          thumbnails: [down_sensr__매입센서_6인치_thumbnails_sen_3in_1],
          energy: true,
          water: false,
        },
        {
          id: "down_sensr__2",
          name: "매입센서_5인치",
          details: [down_sensr__매입센서_5인치_details_s_5in],
          thumbnails: [down_sensr__매입센서_5인치_thumbnails_sen_3in_1],
          energy: true,
          water: false,
        },
        {
          id: "down_sensr__3",
          name: "매입센서_4인치",
          details: [down_sensr__매입센서_4인치_details_s_4in],
          thumbnails: [
            down_sensr__매입센서_4인치_thumbnails_sen_4in_1,
            down_sensr__매입센서_4인치_thumbnails_sen_4in_2,
            down_sensr__매입센서_4인치_thumbnails_sen_4in_3,
            down_sensr__매입센서_4인치_thumbnails_sen_4in_4,
            down_sensr__매입센서_4인치_thumbnails_sen_4in_5,
            down_sensr__매입센서_4인치_thumbnails_sen_4in,
          ],
          energy: true,
          water: false,
        },
        {
          id: "down_sensr__4",
          name: "매입센서_3인치",
          details: [down_sensr__매입센서_3인치_details_s_3in],
          thumbnails: [down_sensr__매입센서_3인치_thumbnails_sen_3in_1],
          energy: true,
          water: false,
        },
      ],
    },
    {
      id: "high_down_lights_",
      name: "high_down_lights_",
      title: "고효율 매입등",
      description: "",
      items: [
        {
          id: "high_down_lights__1",
          name: "6인치_고효율_매입등",
          details: [high_down_lights__6인치_고효율_매입등_details_go_6in],
          thumbnails: [high_down_lights__6인치_고효율_매입등_thumbnails_3in],
          energy: true,
          water: false,
        },
        {
          id: "high_down_lights__2",
          name: "4인치_고효율_매입등",
          details: [high_down_lights__4인치_고효율_매입등_details_go_4in_tot],
          thumbnails: [high_down_lights__4인치_고효율_매입등_thumbnails_3in],
          energy: true,
          water: false,
        },
        {
          id: "high_down_lights__3",
          name: "3인치_고효율_매입등",
          details: [high_down_lights__3인치_고효율_매입등_details_go_3in_tot],
          thumbnails: [high_down_lights__3인치_고효율_매입등_thumbnails_3in],
          energy: true,
          water: false,
        },
      ],
    },
    {
      id: "ic_down_lights",
      name: "ic_down_lights",
      title: "IC 매입등",
      description: "",
      items: [
        {
          id: "ic_down_lights_1",
          name: "IC_매입등_8인치_방습",
          details: [ic_down_lights_IC_매입등_8인치_방습_details_water_8in_down_35w],
          thumbnails: [ic_down_lights_IC_매입등_8인치_방습_thumbnails_8in],
          energy: false,
          water: true,
        },
        {
          id: "ic_down_lights_2",
          name: "IC_매입등_8인치",
          details: [ic_down_lights_IC_매입등_8인치_details_8in_down_35w],
          thumbnails: [ic_down_lights_IC_매입등_8인치_thumbnails_8in],
          energy: false,
          water: false,
        },
        {
          id: "ic_down_lights_3",
          name: "IC_매입등_6인치_20W_방습",
          details: [ic_down_lights_IC_매입등_6인치_20W_방습_details_water_6in_down_20w],
          thumbnails: [
            ic_down_lights_IC_매입등_6인치_20W_방습_thumbnails_01,
            ic_down_lights_IC_매입등_6인치_20W_방습_thumbnails_02,
            ic_down_lights_IC_매입등_6인치_20W_방습_thumbnails_03,
          ],
          energy: false,
          water: true,
        },
        {
          id: "ic_down_lights_4",
          name: "IC_매입등_6인치_20W",
          details: [ic_down_lights_IC_매입등_6인치_20W_details_6in_down_20w],
          thumbnails: [
            ic_down_lights_IC_매입등_6인치_20W_thumbnails_01,
            ic_down_lights_IC_매입등_6인치_20W_thumbnails_02,
            ic_down_lights_IC_매입등_6인치_20W_thumbnails_03,
          ],
          energy: false,
          water: false,
        },
        {
          id: "ic_down_lights_5",
          name: "IC_매입등_6인치_15W_방습",
          details: [ic_down_lights_IC_매입등_6인치_15W_방습_details_water_6in_down],
          thumbnails: [
            ic_down_lights_IC_매입등_6인치_15W_방습_thumbnails_01,
            ic_down_lights_IC_매입등_6인치_15W_방습_thumbnails_02,
            ic_down_lights_IC_매입등_6인치_15W_방습_thumbnails_03,
          ],
          energy: false,
          water: true,
        },
        {
          id: "ic_down_lights_6",
          name: "IC_매입등_6인치_15W",
          details: [ic_down_lights_IC_매입등_6인치_15W_details_6in_down],
          thumbnails: [
            ic_down_lights_IC_매입등_6인치_15W_thumbnails_01,
            ic_down_lights_IC_매입등_6인치_15W_thumbnails_02,
            ic_down_lights_IC_매입등_6인치_15W_thumbnails_03,
          ],
          energy: false,
          water: false,
        },
        {
          id: "ic_down_lights_7",
          name: "IC_매입등_5인치_방습",
          details: [ic_down_lights_IC_매입등_5인치_방습_details_water_5in_down],
          thumbnails: [ic_down_lights_IC_매입등_5인치_방습_thumbnails_5in],
          energy: false,
          water: true,
        },
        {
          id: "ic_down_lights_8",
          name: "IC_매입등_5인치",
          details: [ic_down_lights_IC_매입등_5인치_details_5in_down],
          thumbnails: [ic_down_lights_IC_매입등_5인치_thumbnails_5in],
          energy: false,
          water: false,
        },
        {
          id: "ic_down_lights_9",
          name: "IC_매입등_4인치",
          details: [ic_down_lights_IC_매입등_4인치_details_4in_down],
          thumbnails: [ic_down_lights_IC_매입등_4인치_thumbnails_4in],
          energy: false,
          water: false,
        },
        {
          id: "ic_down_lights_10",
          name: "IC_매입등_3인치_방습",
          details: [ic_down_lights_IC_매입등_3인치_방습_details_water_3in_down],
          thumbnails: [
            ic_down_lights_IC_매입등_3인치_방습_thumbnails_01,
            ic_down_lights_IC_매입등_3인치_방습_thumbnails_02,
            ic_down_lights_IC_매입등_3인치_방습_thumbnails_03,
            ic_down_lights_IC_매입등_3인치_방습_thumbnails_04,
            ic_down_lights_IC_매입등_3인치_방습_thumbnails_05,
            ic_down_lights_IC_매입등_3인치_방습_thumbnails_06,
          ],
          energy: false,
          water: true,
        },
        {
          id: "ic_down_lights_11",
          name: "IC_매입등_3인치",
          details: [ic_down_lights_IC_매입등_3인치_details_3in_down],
          thumbnails: [
            ic_down_lights_IC_매입등_3인치_thumbnails_01,
            ic_down_lights_IC_매입등_3인치_thumbnails_02,
            ic_down_lights_IC_매입등_3인치_thumbnails_03,
            ic_down_lights_IC_매입등_3인치_thumbnails_04,
            ic_down_lights_IC_매입등_3인치_thumbnails_05,
            ic_down_lights_IC_매입등_3인치_thumbnails_06,
          ],
          energy: false,
          water: false,
        },
      ],
    },
    {
      id: "recessed_down_lights",
      name: "recessed_down_lights",
      title: "음푹 매입등",
      description: "",
      items: [
        {
          id: "recessed_down_lights_1",
          name: "음푹매입등_확산_4인치",
          details: [recessed_down_lights_음푹매입등_확산_4인치_details_확산움푹4인치상세],
          thumbnails: [
            recessed_down_lights_음푹매입등_확산_4인치_thumbnails_01,
            recessed_down_lights_음푹매입등_확산_4인치_thumbnails_02,
            recessed_down_lights_음푹매입등_확산_4인치_thumbnails_03,
            recessed_down_lights_음푹매입등_확산_4인치_thumbnails_04,
            recessed_down_lights_음푹매입등_확산_4인치_thumbnails_05,
            recessed_down_lights_음푹매입등_확산_4인치_thumbnails_06,
          ],
          energy: false,
          water: false,
        },
        {
          id: "recessed_down_lights_2",
          name: "음푹매입등_확산_3인치",
          details: [recessed_down_lights_음푹매입등_확산_3인치_details_움푹3인치상세],
          thumbnails: [
            recessed_down_lights_음푹매입등_확산_3인치_thumbnails_01,
            recessed_down_lights_음푹매입등_확산_3인치_thumbnails_02,
            recessed_down_lights_음푹매입등_확산_3인치_thumbnails_03,
            recessed_down_lights_음푹매입등_확산_3인치_thumbnails_04,
            recessed_down_lights_음푹매입등_확산_3인치_thumbnails_05,
            recessed_down_lights_음푹매입등_확산_3인치_thumbnails_06,
          ],
          energy: false,
          water: false,
        },
        {
          id: "recessed_down_lights_3",
          name: "음푹매입등_확산_2인치",
          details: [recessed_down_lights_음푹매입등_확산_2인치_details_확산움푹2인치상세],
          thumbnails: [
            recessed_down_lights_음푹매입등_확산_2인치_thumbnails_01,
            recessed_down_lights_음푹매입등_확산_2인치_thumbnails_02,
            recessed_down_lights_음푹매입등_확산_2인치_thumbnails_03,
            recessed_down_lights_음푹매입등_확산_2인치_thumbnails_04,
            recessed_down_lights_음푹매입등_확산_2인치_thumbnails_05,
            recessed_down_lights_음푹매입등_확산_2인치_thumbnails_06,
          ],
          energy: false,
          water: false,
        },
        {
          id: "recessed_down_lights_4",
          name: "음푹매입등_집중_4인치_화이트",
          details: [recessed_down_lights_음푹매입등_집중_4인치_화이트_details_집중_화이트_4인치],
          thumbnails: [
            recessed_down_lights_음푹매입등_집중_4인치_화이트_thumbnails_02,
            recessed_down_lights_음푹매입등_집중_4인치_화이트_thumbnails_03,
            recessed_down_lights_음푹매입등_집중_4인치_화이트_thumbnails_04,
          ],
          energy: false,
          water: false,
        },
        {
          id: "recessed_down_lights_5",
          name: "음푹매입등_집중_4인치_블랙",
          details: [recessed_down_lights_음푹매입등_집중_4인치_블랙_details_집중_블랙_4인치],
          thumbnails: [
            recessed_down_lights_음푹매입등_집중_4인치_블랙_thumbnails_01,
            recessed_down_lights_음푹매입등_집중_4인치_블랙_thumbnails_05,
            recessed_down_lights_음푹매입등_집중_4인치_블랙_thumbnails_06,
          ],
          energy: false,
          water: false,
        },
        {
          id: "recessed_down_lights_6",
          name: "음푹매입등_집중_3인치_화이트",
          details: [recessed_down_lights_음푹매입등_집중_3인치_화이트_details_집중_화이트_3인치],
          thumbnails: [
            recessed_down_lights_음푹매입등_집중_3인치_화이트_thumbnails_02,
            recessed_down_lights_음푹매입등_집중_3인치_화이트_thumbnails_03,
            recessed_down_lights_음푹매입등_집중_3인치_화이트_thumbnails_04,
          ],
          energy: false,
          water: false,
        },
        {
          id: "recessed_down_lights_7",
          name: "음푹매입등_집중_3인치_블랙",
          details: [recessed_down_lights_음푹매입등_집중_3인치_블랙_details_집중_블랙_3인치],
          thumbnails: [
            recessed_down_lights_음푹매입등_집중_3인치_블랙_thumbnails_01,
            recessed_down_lights_음푹매입등_집중_3인치_블랙_thumbnails_05,
            recessed_down_lights_음푹매입등_집중_3인치_블랙_thumbnails_06,
          ],
          energy: false,
          water: false,
        },
        {
          id: "recessed_down_lights_8",
          name: "음푹매입등_집중_2인치_화이트",
          details: [recessed_down_lights_음푹매입등_집중_2인치_화이트_details_집중_화이트_2인치],
          thumbnails: [
            recessed_down_lights_음푹매입등_집중_2인치_화이트_thumbnails_02,
            recessed_down_lights_음푹매입등_집중_2인치_화이트_thumbnails_03,
            recessed_down_lights_음푹매입등_집중_2인치_화이트_thumbnails_04,
          ],
          energy: false,
          water: false,
        },
        {
          id: "recessed_down_lights_9",
          name: "음푹매입등_집중_2인치_블랙",
          details: [recessed_down_lights_음푹매입등_집중_2인치_블랙_details_집중_블랙_2인치],
          thumbnails: [
            recessed_down_lights_음푹매입등_집중_2인치_블랙_thumbnails_01,
            recessed_down_lights_음푹매입등_집중_2인치_블랙_thumbnails_05,
            recessed_down_lights_음푹매입등_집중_2인치_블랙_thumbnails_06,
          ],
          energy: false,
          water: false,
        },
      ],
    },
    {
      id: "rf_sensr_",
      name: "rf_sensr_",
      title: "RF 센서, 스위치, 히든센서, 재실감지센서",
      description: "",
      items: [
        {
          id: "rf_sensr__1",
          name: "히든센서200",
          details: [rf_sensr__히든센서200_details_200_ss],
          thumbnails: [
            rf_sensr__히든센서200_thumbnails_01,
            rf_sensr__히든센서200_thumbnails_02,
            rf_sensr__히든센서200_thumbnails_03,
            rf_sensr__히든센서200_thumbnails_04,
            rf_sensr__히든센서200_thumbnails_05,
          ],
          energy: true,
          water: false,
        },
        {
          id: "rf_sensr__2",
          name: "히든센서1000",
          details: [rf_sensr__히든센서1000_details_01],
          thumbnails: [
            rf_sensr__히든센서1000_thumbnails_01,
            rf_sensr__히든센서1000_thumbnails_02,
            rf_sensr__히든센서1000_thumbnails_03,
            rf_sensr__히든센서1000_thumbnails_04,
          ],
          energy: true,
          water: false,
        },
        {
          id: "rf_sensr__3",
          name: "벽부형센서",
          details: [
            rf_sensr__벽부형센서_details_KakaoTalk_20241216_151540344,
            rf_sensr__벽부형센서_details_KakaoTalk_20241216_151540344_01,
            rf_sensr__벽부형센서_details_KakaoTalk_20241216_151540344_02,
            rf_sensr__벽부형센서_details_KakaoTalk_20241216_151540344_03,
            rf_sensr__벽부형센서_details_KakaoTalk_20241216_151540344_04,
          ],
          thumbnails: [
            rf_sensr__벽부형센서_thumbnails_01,
            rf_sensr__벽부형센서_thumbnails_02,
            rf_sensr__벽부형센서_thumbnails_03,
            rf_sensr__벽부형센서_thumbnails_04,
          ],
          energy: true,
          water: false,
        },
      ],
    },
  ],
};

export default lightsData;
